import { useQuery } from "react-query";
import { apiCall } from "../../utils";

const getAllMetadata = async () => {
  const { data } = await apiCall.get("/metadata");
  return data;
};

export const useCallAllMetadata = () =>
  useQuery(
    "allMetaData",
    async () => {
      const cachedData = sessionStorage.getItem("allMetaData");
      if (cachedData) {
        return JSON.parse(cachedData);
      } else {
        const data = await getAllMetadata();
        sessionStorage.setItem("allMetaData", JSON.stringify(data));
        return data;
      }
    },
    {
      refetchOnWindowFocus: false,
    },
  );

export default useCallAllMetadata;
